var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pdf',{attrs:{"src":_vm.finalReportUrl,"page":_vm.currentPage},on:{"num-pages":function($event){_vm.pageCount=$event},"page-loaded":function($event){_vm.currentPage=$event},"loaded":_vm.loadPdfHandler}}),_vm._v(" "),_c('Page',{attrs:{"class-name":"page","current":_vm.currentPage,"total":_vm.pageCount,"page-size":1},on:{"on-change":_vm.pageNumChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d92aff","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/base/report/Report.vue
// module id = null
// module chunks = 